import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Italic = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 16 20' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M5.582 1H15'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1 19h9.418'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.296 1 5.714 19'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M5.582 1H15'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1 19h9.418'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.296 1 5.714 19'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    )}
  </IconBase>
);
